import { registryApi } from '../clients/AxiosClients'

export const recuperarOcorrenciasParaCronogramaDeOrdemDeServico = async () => {
	return await registryApi.get(
		`v1/ocorrencia/recuperar-ocorrencias-para-cronograma-de-ordem-de-servico`,
	)
}
